import React from 'react';
import type { TypographyProps } from '@material-ui/core';
import { Typography } from '@material-ui/core';
import {
    TranslationOrChildren,
    type WithTranslation,
} from '../../TranslationOrChildren';

export type ParagraphProps = TypographyProps & WithTranslation;

export const Paragraph: React.FC<ParagraphProps> = ({
    translation,
    translationOptions,
    children,

    variant = 'body1',
    gutterBottom = false,
    ...rest
}) => {
    return (
        <Typography
            variant={variant}
            gutterBottom={gutterBottom}
            data-component="Paragraph"
            {...rest}
        >
            <TranslationOrChildren
                translation={translation}
                translationOptions={translationOptions}
            >
                {children}
            </TranslationOrChildren>
        </Typography>
    );
};
